<template>
    <div>
        <v-dialog v-model="pmrewardsimulationdetaildialog" max-width="1200px">
            <v-card>
                <v-card-title style="position:sticky;top:0;z-index:10;">
                    <span class="headline">
                    <template v-if="formData.staffcode && formData.staffname">
                        {{$t('pmrewardsimulation.editrewardsimulationresult')}} &nbsp;
                        <span class="page_title_value">
                            {{ formData.staffcode }} {{ formData.staffname }}
                        </span>
                    </template>
                    <template v-else>
                        Loading...
                    </template>
                    </span>
                </v-card-title>
                <v-card-text style="max-height:70vh;overflow-y:auto;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.staffname')"
                                    type="text"
                                    v-model="formData.staffname"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n6">
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.staffcode')"
                                    type="text"
                                    v-model="formData.staffcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="formData.companyname"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n6">
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('appraisalrecord.reviewfrom')"
                                    type="text"
                                    v-model="formData.reviewfromdate"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('appraisalrecord.reviewuntil')"
                                    type="text"
                                    v-model="formData.reviewuntildate"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n6">
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('Setupratingscaleset.score')"
                                    type="text"
                                    v-model="formData.score"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('Setuprankmapset.rank')"
                                    type="text"
                                    v-model="formData.rank"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmassementrecord.finalrank')"
                                    type="text"
                                    v-model="formData.finalrank"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n6">
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmrewardsimulation.simulatedIncrement')"
                                    type="text"
                                    v-model="formData.simulatedincreamt"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmrewardsimulation.targetedIncrement')"
                                    type="text"
                                    v-model="formData.targetincreamt"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmrewardsimulation.finalIncrement')"
                                    type="number"
                                    v-model.number="formData.finalincreamt"
                                    :rules="[
                                        rules.required,
                                        rules.isNumber
                                    ]"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n6">
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmrewardsimulation.simulatedBonus')"
                                    type="text"
                                    v-model="formData.simulatedbonusamt"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmrewardsimulation.targetedBonus')"
                                    type="text"
                                    v-model="formData.targetbonusamt"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmrewardsimulation.finalBonus')"
                                    type="number"
                                    v-model.number="formData.finalbonusamt"
                                    :rules="[
                                        rules.required,
                                        rules.isNumber
                                    ]"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{errMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closePmRewardSimulationDetailInput">{{$t('button.cancel')}}</v-btn>
                    <v-btn color="green darken-1" text @click="savePmRewardSimulationDetailInput">{{$t('button.save')}}</v-btn>
                </v-card-actions>
          </v-card>
        </v-dialog>

        <div style="display:flex;justify-content:flex-end;align-items:center;gap:8px;padding:8px 4px;">
                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                  CSV
                </button>
                <div class="gv-search" style="display:flex;align-items:center;gap:6px;background:#F8FAFF;border:1px solid #E8EDF5;border-radius:8px;padding:4px 10px;">
                    <v-icon size="16" style="color:#94A3B8;">mdi-magnify</v-icon>
                    <input v-model="search" type="text" placeholder="Search..." style="border:none;background:transparent;outline:none;font-size:0.85rem;color:#1E293B;width:180px;" />
                </div>
        </div>

        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            :search="search"
            class="elavation-1"
:sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">

                <v-icon
                    small
                    class="ml-2 mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-2 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
        </div>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteItemHandlerAction"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
//import moment from 'moment';

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            //publicPath: process.env.BASE_URL,
            search: "",
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                isNumber: value => !isNaN(value) || this.$t('reportsparam.isnumber'),
                greaterThanZero: value => Number(value) > 0 || this.$t('reportsparam.isGreaterthan0'),
            },

            pmrewardsimulationdetaildialog: false,
            detailItem: this.parentObject.detailItem,

            formData: {
                id: null,
                staffid: null,
                staffname: null,
                staffcode: null,
                companyname:null,
                reviewfromdate:null,
                reviewuntildate:null,
                score: null,
                rank:null,
                finalrank: null,
                simulatedincreamt: null,
                targetincreamt: null,
                finalincreamt: null,
                simulatedbonusamt: null,
                targetbonusamt: null,
                finalbonusamt: null,

                updatedby: this.$store.getters.userId,
                rectimestamp: null,
                stamp: null,
            },

            isEdit: this.parentObject.isEdit,
            // isAdvanceEdit: this.parentObject.isAdvanceEdit,
            isLoading:false,
            isErr: false,
            errMsg: '',
            isConfirm: false,
            messageConfirm:'',
            selectedItem: null, 
        }
    },

    methods: {
        modifyItemHandler(item) {
            if (!item) {
                console.error("⚠️ No item selected for modification!");
                return;
            }
            this.isEdit = true;
            this.formData = {
                ...item,
                staffname: item.staffname || "N/A",
                staffcode: item.staffcode || "N/A",
                companyname: item.companyname || "N/A",
            };
            // Ensure Vue updates the form correctly
            this.$nextTick(() => {
                this.pmrewardsimulationdetaildialog = true;
            });
        },

        deleteItemHandler(item) {
            this.messageConfirm = this.$t('pmrewardsimulation.confirmDeleteDetail', { name: item.staffname });
            this.selectedItem = item;
            this.isConfirm=true;
        },

        deleteItemHandlerAction(){
            if (!this.selectedItem) {
                console.error(" No item selected for deletion!");
                return;
            }
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                console.error("❌ No permission to delete");
                return false;
            }

            this.$store.dispatch('delete', {
                url: "/pmrewardsimulationdetail/"+ vm.selectedItem.id // Send ID as a parameter
            })
            .then(() => {
                const index = vm.detailItem.findIndex(detail => detail.id === vm.selectedItem.id);
                if (index !== -1) {
                    vm.detailItem.splice(index, 1);
                }
                vm.selectedItem = null; // 🔹 Clear after deletion
            })
            .catch((err) => {
                console.error("❌ Error deleting:", err);
                vm.errMsg = err;
            });
            this.$emit("updateCard");
            this.isConfirm = false;  // 🔹 Close confirmation dialog
        },
        
        async savePmRewardSimulationDetailInput() {
            try {
                if (this.isEdit) { // Edit
                    if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                        console.error("❌ No permission to edit");
                        return false;
                    }
                    const res = await this.$store.dispatch('put', {
                        url: "/pmrewardsimulationdetail/edit/" + this.formData.id,
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {//completed update

                        // 🔄 **Update UI without reloading**
                        const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                        if (index !== -1) {
                            this.$set(this.detailItem, index, { ...this.formData }); // Ensure reactivity
                        }

                        this.pmrewardsimulationdetaildialog = false;
                        this.isEdit = false;
                        this.resetSelections();

                        // ✅ **Emit event to notify parent to reload the 6 card**
                        this.$emit("updateCard");
                    }
                }
            } catch (err) {
                // ✅ **Handle 409 Conflict Error Gracefully**
                if (err.response && err.response.status === 409) {
                    this.isErr = true;
                    this.errMsg = "⚠️ The record has been modified recently. Please refresh and try again.";
                } else {
                    this.isErr = true;
                    this.errMsg = err.message || "❌ An unexpected error occurred.";
                }
                console.error("❌ Error in processing:", err);
            }
        },

        closePmRewardSimulationDetailInput() {
            this.pmrewardsimulationdetaildialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            this.resetSelections();
        },



        resetSelections() {
            this.formData = {
                id: null,
                staffid: null,
                staffname: null,
                staffcode: null,
                companyname:null,
                reviewfromdate:null,
                reviewuntildate:null,
                score: null,
                rank:null,
                finalrank: null,
                simulatedincreamt: null,
                targetincreamt: null,
                finalincreamt: null,
                simulatedbonusamt: null,
                targetbonusamt: null,
                finalbonusamt: null,

                updatedby: this.$store.getters.userId,
                rectimestamp: null,
                stamp: null,
            }
            this.pmrewardsimulationdetaildialog= false;
        },

        //This 3 is method use to export CSV
        objectToCSV(data) {
        const csvRows = [];

        //get header
        const headers = Object.keys(data[0]);
        //const headers = this.titles
        csvRows.push(headers.join(","));

        //loop over the rows
        for (const row of data) {
            const values = headers.map((header) => {
            const escaped = ("" + row[header]).replace(/"/g, '\\"');
            return `"${escaped}"`;
            });
            csvRows.push(values.join(","));
        }
        return csvRows.join("\n");
        },
        download(data) {
        const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", this.parentObject.pageTitle + ".csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        },
        async getCSV() {
        let titles = this.parentObject.tabHeader;
        let item = this.detailItem;
        let data = [];
        let obj2 = {};

        titles.forEach((element1) => {
            let x = element1.text;
            obj2[x] = element1.value;
        });

        item.forEach((element1) => {
            let obj = {};
            titles.forEach((element2) => {
            if (element2.value != "action") {
                let key = element2.text;
                obj[key] = element1[element2.value];
            }
            });
            data.push(obj);
        });

        const csvData = this.objectToCSV(data);
        this.download(csvData);
        },
    },

    async mounted() {
        try {
            this.isLoading=true;//nothing to load here
        } catch (err) {
            this.isErr = true;
            this.errMsg = err.message || "An error occurred while loading data";
            console.error("❌ Error in mounted:", err);
        }
    },
}
</script>

<style scoped>
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }
</style>